import { HttpErrorResponse } from '@angular/common/http'
import { createAction, props } from '@ngrx/store'
import { LumpSumBeneficariesWorkpackagesDataResponse } from '../../../features/feature-lump-sum/models/lump-sum-beneficiaries-workpackages-data.interface'
import { LumpSumChangeHistoryBody } from '../../../features/feature-lump-sum/models/lump-sum-change-history.interface'
import { LumpSumCommentsBody } from '../../../features/feature-lump-sum/models/lump-sum-comments.interface'
import { LumpSumDepreciationBody } from '../../../features/feature-lump-sum/models/lump-sum-depreciation.interface'
import { LumpSumWpTableData } from '../../../features/feature-lump-sum/models/lump-sum-wp-table-data.interface'
import { AppBasicBeneficiary } from '../../models/interfaces/app-basic-beneficiary.interface'
import { AppBasicResourceTypesResponse } from '../../models/interfaces/app-basic-resource-types.interface'
import { AppBasicWorkpackage } from '../../models/interfaces/app-basic-workpackage.interface'

// beneficiaries list
export const load_LS_BeneficiariesList = createAction('[lump-sum] load_LS_BeneficiariesList')

export const load_LS_BeneficiariesListSuccess = createAction('[lump-sum] load_LS_BeneficiariesListSuccess', props<{ response: AppBasicBeneficiary[] }>())

export const load_LS_BeneficiariesListFailure = createAction('[lump-sum] load_LS_BeneficiariesListFailure', props<{ error: HttpErrorResponse }>())

// wp
export const load_LS_Workpackages = createAction('[lump-sum] load_LS_Workpackages')

export const load_LS_WorkpackagesSuccess = createAction('[lump-sum] load_LS_WorkpackagesSuccess', props<{ response: AppBasicWorkpackage[] }>())

export const load_LS_WorkpackagesFailure = createAction('[lump-sum] load_LS_WorkpackagesFailure', props<{ error: HttpErrorResponse }>())

// Summary for WP
export const load_LS_SummaryForWpData = createAction('[lump-sum] load_LS_SummaryForWpData', props<{ workPackageId: number }>())

export const load_LS_SummaryForWpDataSuccess = createAction('[lump-sum] load_LS_SummaryForWpDataSuccess', props<{ response: LumpSumWpTableData }>())

export const load_LS_SummaryForWpDataFailure = createAction('[lump-sum] load_LS_SummaryForWpDataFailure', props<{ error: HttpErrorResponse }>())

// COSTS PER WP

export const load_LS_CostsPerWpBeneficiarySummaryTableData = createAction(
   '[lump-sum] load_LS_CostsPerWpBeneficiarySummaryTableData',
   props<{ beneficiaryId: number }>()
)

export const load_LS_CostsPerWpBeneficiarySummaryTableDataSuccess = createAction(
   '[lump-sum] load_LS_CostsPerWpBeneficiarySummaryTableDataSuccess',
   props<{ response: LumpSumWpTableData }>()
)

export const load_LS_CostsPerWpBeneficiarySummaryTableDataFailure = createAction(
   '[lump-sum] load_LS_CostsPerWpBeneficiarySummaryTableDataFailure',
   props<{ error: HttpErrorResponse }>()
)

export const load_LS_CostsPerWpSingleWpTableData = createAction(
   '[lump-sum] load_LS_CostsPerWpSingleWpTableData',
   props<{ beneficiaryId: number; workPackageId: number }>()
)

export const load_LS_CostsPerWpSingleWpTableDataSuccess = createAction(
   '[lump-sum] load_LS_CostsPerWpSingleWpTableDataSuccess',
   props<{ response: LumpSumWpTableData }>()
)

export const load_LS_CostsPerWpSingleWpTableDataFailure = createAction(
   '[lump-sum] load_LS_CostsPerWpSingleWpTableDataFailure',
   props<{ error: HttpErrorResponse }>()
)

export const update_LS_CostsPerWpSingleWpTableData = createAction(
   '[lump-sum] update_LS_CostsPerWpSingleWpTableData',
   props<{ beneficiaryId: number; workPackageId: number; requestBody: LumpSumWpTableData }>()
)

export const update_LS_CostsPerWpSingleWpTableDataSuccess = createAction('[lump-sum] update_LS_CostsPerWpSingleWpTableDataSuccess')

export const update_LS_CostsPerWpSingleWpTableDataFailure = createAction(
   '[lump-sum] update_LS_CostsPerWpSingleWpTableDataFailure',
   props<{ error: HttpErrorResponse }>()
)

// estimated breakdown
export const load_LS_EstimatedBreakdownData = createAction('[lump-sum] load_LS_EstimatedBreakdownData')

export const load_LS_EstimatedBreakdownDataSuccess = createAction(
   '[lump-sum] load_LS_EstimatedBreakdownDataSuccess',
   props<{ response: LumpSumBeneficariesWorkpackagesDataResponse }>()
)

export const load_LS_EstimatedBreakdownDataFailure = createAction('[lump-sum] load_LS_EstimatedBreakdownDataFailure', props<{ error: HttpErrorResponse }>())

// person months
export const load_LS_PersonMonthsData = createAction('[lump-sum] load_LS_PersonMonthsData')

export const load_LS_PersonMonthsDataSuccess = createAction(
   '[lump-sum] load_LS_PersonMonthsDataSuccess',
   props<{ response: LumpSumBeneficariesWorkpackagesDataResponse }>()
)

export const load_LS_PersonMonthsDataFailure = createAction('[lump-sum] load_LS_PersonMonthsDataFailure', props<{ error: HttpErrorResponse }>())

// depreciation
export const load_LS_DepreciationData = createAction('[lump-sum] load_LS_DepreciationData', props<{ beneficiaryId: number; workPackageId: number }>())

export const load_LS_DepreciationDataSuccess = createAction('[lump-sum] load_LS_DepreciationDataSuccess', props<{ response: LumpSumDepreciationBody }>())

export const load_LS_DepreciationDataFailure = createAction('[lump-sum] load_LS_DepreciationDataFailure', props<{ error: HttpErrorResponse }>())

export const update_LS_DepreciationData = createAction(
   '[lump-sum] update_LS_DepreciationData',
   props<{ beneficiaryId: number; workPackageId: number; requestBody: LumpSumDepreciationBody }>()
)

export const update_LS_DepreciationDataSuccess = createAction('[lump-sum] update_LS_DepreciationDataSuccess')

export const update_LS_DepreciationDataFailure = createAction('[lump-sum] update_LS_DepreciationDataFailure', props<{ error: HttpErrorResponse }>())

// general
export const cleanLumpSumData = createAction('[lump-sum] cleanLumpSumData')

// resource types for depreciation costs
export const load_LS_ResourceTypes = createAction('[lump-sum] load_LS_ResourceTypes')

export const load_LS_ResourceTypesSuccess = createAction('[lump-sum] load_LS_ResourceTypesSuccess', props<{ response: AppBasicResourceTypesResponse }>())

export const load_LS_ResourceTypesFailure = createAction('[lump-sum] load_LS_ResourceTypesFailure', props<{ error: HttpErrorResponse }>())

// any comments

export const load_LS_AnyCommentsData = createAction('[lump-sum] load_LS_AnyCommentsData', props<{ beneficiaryId: number; workPackageId: number }>())

export const load_LS_AnyCommentsDataSuccess = createAction('[lump-sum] load_LS_AnyCommentsDataSuccess', props<{ response: LumpSumCommentsBody }>())

export const load_LS_AnyCommentsDataFailure = createAction('[lump-sum] load_LS_AnyCommentsDataFailure', props<{ error: HttpErrorResponse }>())

export const update_LS_AnyCommentsData = createAction(
   '[lump-sum] update_LS_AnyCommentsData',
   props<{ beneficiaryId: number; workPackageId: number; requestBody: LumpSumCommentsBody }>()
)

export const update_LS_AnyCommentsDataSuccess = createAction('[lump-sum] update_LS_AnyCommentsDataSuccess')

export const update_LS_AnyCommentsDataFailure = createAction('[lump-sum] update_LS_AnyCommentsDataFailure', props<{ error: HttpErrorResponse }>())

// change log

export const load_LS_ChangeHistoryData = createAction('[lump-sum] load_LS_ChangeHistoryData')

export const load_LS_ChangeHistoryDataSuccess = createAction('[lump-sum] load_LS_ChangeHistoryDataSuccess', props<{ response: LumpSumChangeHistoryBody }>())

export const load_LS_ChangeHistoryDataFailure = createAction('[lump-sum] load_LS_ChangeHistoryDataFailure', props<{ error: HttpErrorResponse }>())

export const update_LS_ChangeHistoryData = createAction('[lump-sum] update_LS_ChangeHistoryData', props<{ requestBody: LumpSumChangeHistoryBody }>())

export const update_LS_ChangeHistoryDataSuccess = createAction('[lump-sum] update_LS_ChangeHistoryDataSuccess')

export const update_LS_ChangeHistoryDataFailure = createAction('[lump-sum] update_LS_ChangeHistoryDataFailure', props<{ error: HttpErrorResponse }>())

// download lumpsum excel
export const downloadLumpSum = createAction('[lump-sum] downloadLumpSum')

export const downloadLumpSumSuccess = createAction('[lump-sum] downloadLumpSumSuccess', props<{ response: any }>())

export const downloadLumpSumFailure = createAction('[lump-sum] downloadLumpSumFailure', props<{ error: HttpErrorResponse }>())

export const closeExportProgress = createAction('[lump-sum] closeExportProgress')
